import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/storefront/src/app/regalar/components/RegalarClient.tsx");
